import type { ISerialize } from '@/objects/ISerialize';
import type { JsonWebTokenProvider } from './../enums/JsonWebTokenProvider';

export class JsonWebToken implements ISerialize {
    public Payload: string | null;

    public Provider: JsonWebTokenProvider;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Payload?: string | null; Provider?: JsonWebTokenProvider }) {
        this.Payload = values.Payload ?? null;

        this.Provider = values.Provider ?? 'Google';
    }

    public serialize(): string {
        return (
            '{' +
            `"Payload": ${JSON.stringify(this.Payload)}` +
            ',' +
            `"Provider": ${this.Provider == 'Google' ? 0 : this.Provider == 'FedCM' ? 1 : 0}` +
            '}'
        );
    }

    /**
     * Creates an instance of JsonWebToken from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Payload?: string | null; Provider?: JsonWebTokenProvider }): JsonWebToken {
        return new JsonWebToken(values);
    }

    public static _FromServerJson(json: any): JsonWebToken {
        return new JsonWebToken({
            Payload: json.Payload ?? '',
            Provider: json.Provider == 0 ? 'Google' : json.Provider == 1 ? 'FedCM' : 'Google',
        });
    }

    /**
     * Creates an instance of JsonWebToken from another instance of JsonWebToken.
     * @param other The JsonWebToken you want to clone
     * @returns A cloned JsonWebToken
     */
    public static FromOther(other: JsonWebToken): JsonWebToken {
        return JsonWebToken._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return JsonWebToken.FromOther(this);
    }

    static NAME_OF_CLASS = 'JsonWebToken';
}
